import React, { useEffect, useState } from 'react'
import { useOutletContext, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Container, Col, Row } from 'react-bootstrap'

import BackLinkButton from 'Shared/Components/BackLinkButton'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import { FloatingInputDisabled } from 'Shared/Components/FloatingLabel/FloatingLabel'
import moment from 'moment'

const NetworkRouter = () => {
  const { profile, role, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { device_id } = useParams()
  
  const { send } = useFetchData()
  const navigate = useNavigate()

  const [data, setData] = useState()

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      const body = await send({
        method: "GET",
        url: `${apiUrl}/network_router/router_log/latest`,
        params: {
          "device_id": device_id
        },
        returnType: "json"
      })

      setData({
        "device_name": body["device_name"],
        "last_update": body["last_update"] ? moment(body["last_update"]).format("YYYY-MM-DD HH:mm:ss") : null,
        "message": JSON.parse(body["message"]),
      })

      setPageLoading(false)
    }

    init()
  }, [])

  return (<>
    <Container fluid className="mainContainer" style={{ borderRadius: "15px", backgroundColor: "white" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", paddingLeft: 0, paddingRight: 0, display: "flex", flexFlow: "column"  }}>
          <BackLinkButton />

          {data && 
            <div style={{ flexGrow: 1, overflow: "auto", margin: "10px", paddingLeft: "10px", paddingRight: "10px" }}>
              <Container fluid>
                <Row className="mt-1 mb-1">
                  <Col xs={12} lg={4}>
                    <FloatingInputDisabled label="Device Name" name="device" value={data["device_name"]} />
                  </Col>

                  <Col xs={12} lg={4}>
                    <FloatingInputDisabled label="Last Update" name="device" value={data["last_update"] ?? "-"} />
                  </Col>
                </Row>
                
                <Row style={{ marginTop: "20px" }}>
                  <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
                    {data["message"] && <>
                      <div>
                        <pre>
                          {JSON.stringify(data["message"], null, 2)}
                        </pre>
                      </div>
                    </>}
                  </Col>
                </Row>
              </Container> 
            </div>
          }
        </Col>
      </Row>
    </Container>
  </>)
}

export default NetworkRouter
